var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { GridRows as VisxGridRows, GridColumns as VisxGridColumns } from '@visx/grid';
import { useCanvas } from '../components/Canvas';
import { palette } from '../../constants';
export var gridStyleProps = {
    stroke: palette.neutral3
};
export function GridRows(props) {
    var widthProp = props.width, scale = props.scale, rest = __rest(props, ["width", "scale"]);
    var boundedWidth = useCanvas().boundedWidth;
    var width = widthProp !== null && widthProp !== void 0 ? widthProp : boundedWidth;
    return (React.createElement(VisxGridRows, __assign({ scale: scale, width: width }, rest, gridStyleProps)));
}
export function GridColumns(props) {
    var heightProp = props.height, scale = props.scale, rest = __rest(props, ["height", "scale"]);
    var boundedHeight = useCanvas().boundedHeight;
    var height = heightProp !== null && heightProp !== void 0 ? heightProp : boundedHeight;
    return (React.createElement(VisxGridColumns, __assign({ scale: scale, height: height }, rest, gridStyleProps)));
}
//# sourceMappingURL=Grid.js.map